<template>
    <q-radio
      :val="val"
      :value="value"
      :label="label"
      :disable="disable"
      :size="size"
      :dense="dense"
      :color="color"
      :keep-color="keepColor"
      v-on="$listeners"/>
</template>

<script>
export default {
  name: 'RRadio',
  props: {
    val: {
      type: [String, Number, Boolean],
      required: true,
    },
    value: [String, Number, Boolean],
    label: String,
    disable: Boolean,
    size: String,
    dense: Boolean,
    keepColor: Boolean,
    color: String,
  },
};
</script>
